import React, { useMemo } from 'react'
import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import LocalOfferOutlined from '@mui/icons-material/LocalOfferOutlined'

import { ActionCardProps } from 'types/TextAnalysis'

const CardActions = ({
  index,
  anchorElMap,
  onClickAddTag,
  $focused,
  innerRef,
}: ActionCardProps) => {
  const isIconVisible = useMemo(
    () => Boolean(anchorElMap?.[index ?? -1]) || $focused,
    [anchorElMap, index, $focused],
  )

  return (
    <Box sx={{ position: 'absolute', top: '0.25rem', right: '0.25rem' }}>
      <Tooltip title="Add tag" ref={innerRef}>
        <IconButton
          className={`add-tag-icon ${isIconVisible ? 'visible' : ''}`}
          onClick={onClickAddTag}
          data-testid="add-tag-btn-id"
          sx={{
            opacity: isIconVisible ? 1 : 0,
            '@media (max-width: 1024px)': {
              display: 'none',
              pointerEvents: 'none',
            },
          }}
        >
          <LocalOfferOutlined fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  )
}

export default React.memo(CardActions)
